import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import PublicLayout from './components/PublicLayout';
import PortalLayout from './components/PortalLayout';
import RequireAuth from './components/RequireAuth';
import HomePage from './pages/HomePage';
import RequestPage from './pages/RequestPage';
import OfferPage from './pages/OfferPage';
import LoginPage from './pages/LoginPage';
import PasswordResetPage from './pages/PasswordResetPage';
import QualificationPage from './pages/QualificationPage';
import DashboardPage from './pages/DashboardPage';
import InterestsPage from './pages/InterestsPage';
import TenantAdminPage from './pages/TenantAdminPage';
import AdminRequestsPage from './pages/AdminRequestsPage';
import AdminRequestMonitoringPage from './pages/AdminRequestMonitoringPage';
import RequestVerificationPage from './pages/RequestVerificationPage';
import { getUser, isLoggedIn } from './utils/auth';

function PortalRedirect() {
  if (!isLoggedIn()) return <Navigate to="/login" replace />;
  return <Navigate to={getUser()?.role === 'platform_admin' ? '/admin/mandanten' : '/portal'} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/anfrage" element={<RequestPage />} />
          <Route path="/anfrage-bestaetigen/:token" element={<RequestVerificationPage />} />
          <Route path="/angebot/:token" element={<OfferPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/passwort-zuruecksetzen/:token" element={<PasswordResetPage />} />
          <Route path="/qualifiziertes-angebot/:token" element={<QualificationPage />} />
        </Route>

        <Route element={<RequireAuth roles={['tenant_admin', 'tenant_user']}><PortalLayout /></RequireAuth>}>
          <Route path="/portal" element={<DashboardPage />} />
          <Route path="/portal/maschinentypen" element={<InterestsPage />} />
        </Route>

        <Route element={<RequireAuth roles={['platform_admin']}><PortalLayout /></RequireAuth>}>
          <Route path="/admin/mandanten" element={<TenantAdminPage />} />
          <Route path="/admin/anfragen" element={<AdminRequestsPage />} />
          <Route path="/admin/anfrage-monitoring" element={<AdminRequestMonitoringPage />} />
        </Route>

        <Route path="/app" element={<PortalRedirect />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
